<template>
  <v-container>
    <v-flex xs12>
      <v-text-field
        outlined
        dense
        v-model="model.title"
        type="email"
        label="Alert Title"
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        outlined
        dense
        v-model="model.body"
        type="email"
        label="Alert Body"
      />
    </v-flex>
    <v-flex xs12>
      <groups-drop-down
        :init-groups="model.groups"
        @select-item="groupSelectionChanged"
      />
    </v-flex>
  </v-container>
</template>
<script>
import { get } from 'lodash'
import GroupsDropDown from "../Common/GroupsDropDown"

export default {
  components: {
    GroupsDropDown
  },
  props: {
    eventItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: {
        title: '',
        body: '',
        groups: []
      }
    }
  },
  watch: {
    model: {
      handler() {
        this.$emit('change', this.model)
      },
      deep: true
    },
    eventItem() {
      this.resetMeta()
    }
  },
  mounted() {
    this.resetMeta()
  },
  methods: {
    resetMeta() {
      // we are only modeling the meta data
      const meta = get(this.eventItem, 'meta', {})
      this.model = { ...meta }
    },
    groupSelectionChanged(groups) {
      this.model = {
        ...this.model,
        groups: Array.isArray(groups) ? groups : []
      }
    }
  }
}
</script>
